import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IFormJBPHPContactRoles } from 'legacy/lut/classes/models/partner360/IFormHPContacts'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

export const getJbpHpContactRolesCrud = () =>
  CrudStore.get(
    CrudStoreItemPartner360.JBPHPContactRoles,
    'JBPHPContactRoles'
  ) as Crud<IFormJBPHPContactRoles>
